/**
 * Created by Dustin on 10.5.2018.
 */
import {UserActions} from '../const/ActionsConst';
import * as actions from './index.js';
import client from '@common/utils/rest.js'
const I18n = require('react-redux-i18n').I18n;

export const showChangePasswordWnd = (show, id) => ({
    type: UserActions.SHOW_CHANGE_PWD_WND,
    changePassword: {
        show: show,
        username: id
    }
});

export const updateChangePasswordData = (field, value) => ({
    type: UserActions.UPDATE_CHANGE_PWD_DATA,
    changePassword: {
        field: field,
        value: value
    }
});

export const changePassword = () => (dispatch,getState) => {
    if (!getState().changePassword.password || getState().changePassword.password.length === 0) {
        dispatch(actions.showMessageBoxBasedOnData(undefined, true, I18n.t('Change Password Canceled'), I18n.t('pwRequirements'), undefined, I18n.t('Cancel')));
    } else if (getState().changePassword.password !== getState().changePassword.retypedPassword) {
        dispatch(actions.showMessageBoxBasedOnData(undefined, true, I18n.t('Change Password Canceled'), I18n.t('Two different passwords were entered in the password fields'), undefined, I18n.t('Cancel')));
    } else {
        var userData = {
            username: getState().changePassword.username,
            password: getState().changePassword.password,
            retypedPassword: getState().changePassword.retypedPassword
        };
        client({
            path: 'api/userMaintenance/changePassword',
            method: 'POST',
            entity: userData
        }).then(
            response => {
                if (response.entity.error) {
                    dispatch(actions.showMessageBoxBasedOnData(undefined, true, I18n.t('Change Password Canceled'), response.entity.error, undefined, I18n.t('Cancel')));
                } else {
                    dispatch(actions.showMessageBoxBasedOnData(undefined, true, I18n.t('Change Password'), I18n.t('The password was successfully changed'), undefined, I18n.t('OK')));
                    dispatch(clearChangePasswordData());
                }
            },
            error => {console.log('changePassword: ', error);}
        )
    }
};

export const clearChangePasswordData = () => ({
    type: UserActions.CLEAR_CHANGE_PWD_DATA
});